import Image, { ImageProps } from 'next/image';

import { IconPenRound } from '@/components/apps/ui/icon';

import theme from '@/styles/theme';

import ButtonIcon from '../buttons/ButtonIcon';

export type ProfileSizeType = 'sm' | 'md' | 'lg';

/** AvatarUpload 가 Emotion 템플릿 안에서 쓰므로 px 값도 함께 내보낸다 */
export const PROFILE_SIZE_PX: Record<ProfileSizeType, number> = {
  sm: 32,
  md: 40,
  lg: 100,
};

const SIZE_CLASS: Record<ProfileSizeType, string> = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-[100px] w-[100px]',
};

// ImageProps의 필수 타입인 src와 alt를 옵셔널하게 처리하기 위해 Omit 사용
interface Props extends Omit<ImageProps, 'src' | 'alt'> {
  size?: ProfileSizeType;
  isEditable?: boolean;
  onClick?: () => void;
  src?: string;
  alt?: string;
}

export default function Profile({
  size = 'md',
  isEditable = false,
  onClick,
  src,
  alt,
  className,
  ...props
}: Props) {
  return (
    <div
      className={`relative ${SIZE_CLASS[size]} ${
        onClick ? 'cursor-pointer' : 'cursor-default'
      } ${className ?? ''}`}
    >
      <Image
        {...props}
        src={src || '/images/apps/common/no_img_profile.svg'}
        alt={alt || 'profile image'}
        fill
        style={{
          position: 'absolute',
          objectFit: 'cover',
          borderRadius: '50%',
        }}
      />
      {onClick && (
        <button
          type="button"
          aria-label={alt || '프로필 열기'}
          className="absolute inset-0 z-10 rounded-full"
          onClick={onClick}
        />
      )}
      {isEditable && size === 'lg' && (
        <div className="absolute bottom-0 right-0 z-20">
          <ButtonIcon
            variant="ellipse"
            emphasis="light"
            aria-label="프로필 수정"
            onClick={onClick}
          >
            <IconPenRound size={16} color={theme`colors.apps.coreGrayWhite`} />
          </ButtonIcon>
        </div>
      )}
    </div>
  );
}
